export enum Period {
    YearToDate = "YearToDate",
    OneWeek = "OneWeek",
    OneMonth = "OneMonth",
    ThreeMonths = "ThreeMonths",
    SixMonths = "SixMonths",
    OneYear = "OneYear",
    TwoYears = "TwoYears",
    ThreeYears = "ThreeYears",
    FiveYears = "FiveYears",
    TenYears = "TenYears"
}
